"use strict";
/* eslint-disable react/prop-types */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const bottom_sheet_1 = require("@gorhom/bottom-sheet");
const react_1 = __importStar(require("react"));
const ReanimatedBottomSheetContext_1 = require("../ReanimatedBottomSheetContext");
const ReanimatedBottomSheetModal = react_1.default.forwardRef((props, bottomSheetModalRef) => {
    const { children, index = 0, snapPoints = ['25%', '50%', '75%', '90%'], enablePanDownToClose = true, headerComponent = null, footerComponent = bottom_sheet_1.BottomSheetFooter, backdropComponent = bottom_sheet_1.BottomSheetBackdrop, handleComponent = bottom_sheet_1.BottomSheetHandle, ...restProps } = props;
    const { dispatch } = ReanimatedBottomSheetContext_1.useReanimatedBottomSheet();
    react_1.useEffect(() => {
        dispatch({
            type: ReanimatedBottomSheetContext_1.SET_SNAPPOINTS,
            snapPoints,
        });
    }, [snapPoints]);
    const memoizedSnapPoints = react_1.useMemo(() => snapPoints, []);
    return (react_1.default.createElement(bottom_sheet_1.BottomSheetModal, Object.assign({}, restProps, { ref: bottomSheetModalRef, index: index, snapPoints: memoizedSnapPoints, enablePanDownToClose: enablePanDownToClose, handleComponent: handleComponent, backdropComponent: backdropComponent, footerComponent: footerComponent }),
        typeof headerComponent === 'function'
            ? headerComponent()
            : headerComponent,
        children));
});
exports.default = ReanimatedBottomSheetModal;
